// R8-IMP-DEDUP — vista "Da verificare": le voci NUOVE marcate da_verificare (simili per
// contenimento a una esistente) mostrate ciascuna ACCANTO alla simile, con azioni:
//   "Sono la stessa · tieni la nuova"      -> unisci(tieni=nuova, rimuovi=esistente)
//   "Sono la stessa · tieni l'esistente"   -> unisci(tieni=esistente, rimuovi=nuova)
//   "Sono diverse"                         -> togli il badge (restano separate)
// Porta l'artigiano ALLE da-verificare invece di lasciargliele cercare.
import React, { useState, useEffect, useCallback } from 'react';
import { listino } from '../utils/api';

const eur = (x) => `€ ${(Number(x) || 0).toFixed(2).replace('.', ',')}`;

export default function ListinoDaVerificare({ onChiudi, onCambiato }) {
  const [voci, setVoci] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState('');

  const fetch = useCallback(() => {
    setLoading(true);
    setError('');
    listino.list({ stato_import: 'da_verificare', page_size: 100 })
      .then((res) => setVoci(res.data?.results || res.data || []))
      .catch(() => setError('Non riesco a caricare le voci da verificare.'))
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => { fetch(); }, [fetch]);

  const azione = async (id, fn) => {
    setBusy(id);
    setError('');
    try { await fn(); fetch(); onCambiato && onCambiato(); }
    catch { setError('Operazione non riuscita. Riprova.'); }
    finally { setBusy(null); }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, gap: 12, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 16, fontWeight: 500, margin: 0 }}>Da verificare ({voci.length})</h2>
        <button onClick={onChiudi} style={btn}>← Torna al listino</button>
      </div>
      {error && <div style={{ color: 'var(--ds-danger)', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      {loading ? (
        <div style={{ padding: 20, color: 'var(--ds-muted)' }}>Caricamento…</div>
      ) : voci.length === 0 ? (
        <div style={{ padding: 30, textAlign: 'center', color: 'var(--ds-muted)' }}>
          Niente da verificare. 👍
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {voci.map((v) => (
            <div key={v.id} style={card}>
              <div style={{ fontSize: 12, color: 'var(--ds-muted)', marginBottom: 8 }}>
                Assomiglia a una voce già presente — è la stessa o è diversa?
              </div>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ fontSize: 11, color: 'var(--ds-muted)', textTransform: 'uppercase' }}>Nuova (dall'import)</div>
                  <div style={{ fontSize: 14, color: 'var(--ds-text)' }}>{v.descrizione}</div>
                  <div style={{ fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                    {eur(v.prezzo_unitario)}{v.unita_misura ? ` / ${v.unita_misura}` : ''}
                  </div>
                </div>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ fontSize: 11, color: 'var(--ds-muted)', textTransform: 'uppercase' }}>Esistente simile</div>
                  <div style={{ fontSize: 14, color: 'var(--ds-text)' }}>{v.voce_simile_descrizione || '—'}</div>
                  <div style={{ fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>
                    {v.voce_simile_prezzo != null ? eur(v.voce_simile_prezzo) : '—'}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                <button disabled={busy === v.id}
                  onClick={() => azione(v.id, () => listino.unisci(v.id, v.voce_simile))} style={btnP}>
                  Sono la stessa · tieni la nuova
                </button>
                {v.voce_simile && (
                  <button disabled={busy === v.id}
                    onClick={() => azione(v.id, () => listino.unisci(v.voce_simile, v.id))} style={btn}>
                    Sono la stessa · tieni l'esistente
                  </button>
                )}
                <button disabled={busy === v.id}
                  onClick={() => azione(v.id, () => listino.archiviaBadge(v.id))} style={btn}>
                  Sono diverse
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const card = { border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: '12px 14px', background: 'var(--ds-bg)' };
const btn = { padding: '7px 12px', borderRadius: 6, border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ds-text)', cursor: 'pointer', fontSize: 12 };
const btnP = { padding: '7px 12px', borderRadius: 6, border: 'none', background: 'var(--brand)', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 500 };
